module.exports = __webpack_public_path__ + "0af09df5d77b83d85ae10f49622ba9a8.jpg";